<template>
<div class="app__page -options">
      <mobile-menu />
      <div class="page__wrapper" ref="pageWrapper">
        <div class="header">
            <i @click="toggleMenu()" class="far fa-bars" id="menu-icon"></i>
            <img class="header__logo" src="static/logo.png"/>
        </div>
        <div class="crumbs">
      <div class="crumbs__container">
        <div class="crumb header__buttons">
          <div class="header__buttons__button" @click="go('size')"><i class="far fa-sync-alt"></i></div>
          <div class="header__buttons__button" @click="go('options')"><i class="fas fa-cog __settings"></i></div>
        </div>
      </div>
  </div>
        <div class="content-area">
          <div class="content-area__container">
                <p class="cooker-count">300 cookers in the catalogue</p>
                <button class="update-btn" @click="updateCache" type="button" :disabled="is_updating">Update</button>
                <p class="last-update">Last updated on: {{updated_on}}</p>
          </div>
          <div class="progress-bar__container">
              <div class="progress-bar">
                <div class="progress-bar__bar" :style="{width: progress}"></div>
              </div>
              <ul>
                <li v-for="i in item" :key="i">{{i}}</li>
              </ul>
            <button type="button" @click="goback" :disabled="is_updating">Back</button>
          </div>
        </div>
        <div class="footer-area">
            <p>Contact us 0800 8046261</p>
        </div>
      </div>
    </div>

</template>

<script>
import { getDatabase } from "../../api/index.js";
import MobileMenu from '../ui/mobile-menu.vue';

export default {
  data: function() {
    return {
      is_updating: false,
      progress: "0%",
      item: ["waiting"],
      updated_on: "Fetching"
    };
  },
  methods: {
    updateCache() {
      this.is_updating = true;
      getDatabase()
        .update((cur, total, item) => {
          this.progress = Math.floor(cur / total * 100) + "%";
          this.item = Array.isArray(item) ? item : [item];
        })
        .then(
          async () => {
            alert("Updated");
            getDatabase()
              .lastUpdate()
              .then(d => {
                this.updated_on = (new Date(d)).toLocaleString();
              });
            this.is_updating = false;
          },
          err => {
            alert("Failed to update, please try again.");
            this.is_updating = false;
            console.error(err);
          }
        );
    },
    goback() {
      this.$router.go(-1);
    },
    toggleMenu(){
      document.querySelector(".push__menu").classList.contains("open") ? document.querySelector(".push__menu").classList.remove("open") : document.querySelector(".push__menu").classList.add("open");
    }
  },
  mounted() {
    getDatabase()
      .lastUpdate()
      .then(d => {
        this.updated_on = (new Date(d)).toLocaleString();
      });
  },
  components: {
      mobileMenu: MobileMenu
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/page-options.vue